import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { CurrencyProvider } from "@/lib/currency";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const tree = (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <CurrencyProvider>
        <App />
      </CurrencyProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

const rootEl = document.getElementById("root");
// Prerendered HTML is only safe to hydrate on the route it was rendered for.
// Any other route (e.g. /admin served via SPA fallback) must render from scratch.
const prerenderedPath = document.querySelector('meta[name="prerender-path"]')?.content;
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
if (rootEl.hasChildNodes() && prerenderedPath === currentPath) {
  hydrateRoot(rootEl, tree);
} else {
  rootEl.innerHTML = "";
  createRoot(rootEl).render(tree);
}
